import { render, staticRenderFns } from "./EditWhoModal.vue?vue&type=template&id=715f1a36&"
import script from "./EditWhoModal.vue?vue&type=script&lang=js&"
export * from "./EditWhoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports